module.exports = __webpack_public_path__ + "media/images/copy-22371a40a6eac9b954b6355c2ea21029.svg";